import { render, staticRenderFns } from "@/components/Layout/Menu/Administracion/Administracion_patentes/Editar_patentes/Editar_patentes.html?vue&type=template&id=35a64047&scoped=true&"
import script from "@/components/Layout/Menu/Administracion/Administracion_patentes/Editar_patentes/Editar_patentes.js?vue&type=script&lang=js&"
export * from "@/components/Layout/Menu/Administracion/Administracion_patentes/Editar_patentes/Editar_patentes.js?vue&type=script&lang=js&"
import style0 from "@/components/Layout/Menu/Administracion/Administracion_patentes/Editar_patentes/Editar_patentes.css?vue&type=style&index=0&id=35a64047&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a64047",
  null
  
)

export default component.exports